// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: 'locaSkin_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '36ba41aa-672b-44e5-a9d3-42499b58ec2c',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 15,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.6
      },
      angle: 0,
      alpha: 0.7,
      visible: true,
      tint: 5953,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Event_Title_Back_Glow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          scale: {
            x: 1.070234,
            y: 0.590909
          },
          y: 15
        },
        fr_FR: {
          scale: {
            y: 0.636364,
            x: 1.086957
          },
          x: 0,
          y: 17
        },
        de_DE: {
          scale: {
            y: 0.636364,
            x: 1.103679
          },
          x: 0,
          y: 20
        },
        es_ES: {
          scale: {
            x: 1.086957,
            y: 0.590909
          },
          y: 17
        },
        pt_PT: {
          scale: {
            y: 0.590909,
            x: 1.103679
          },
          y: 20
        },
        pl_PL: {
          scale: {
            y: 0.681818,
            x: 1.120401
          },
          x: 0,
          y: 18
        },
        nl_NL: {
          scale: {
            x: 1.103679,
            y: 0.636364
          },
          y: 15
        },
        ko_KR: {
          scale: {
            x: 0.685619,
            y: 0.636364
          },
          x: -10,
          y: 16
        },
        jp_JP: {
          scale: {
            x: 0.752508,
            y: 0.681818
          }
        }
      }
    },
    {
      id: '6426a61e-1865-4c6f-9733-7d8760ac9b1b',
      type: 'Text',
      name: '',
      className: '',
      x: -90,
      y: -40,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -5,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Win',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#24a1fe',
        stroke: '#fff8d9',
        strokeThickness: 10,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 95.8,
        dropShadowBlur: 0,
        dropShadowColor: '#c18d6c',
        dropShadowDistance: 8,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          text: 'Vittorie',
          style: {
            fontSize: 65,
            dropShadowAngle: 96.2
          },
          angle: 5,
          x: 162,
          y: 0
        },
        en_US: {
          style: {
            dropShadowAngle: 95.5
          }
        },
        fr_FR: {
          text: 'Victoire',
          style: {
            fontSize: 70,
            dropShadowAngle: 96.2
          },
          angle: 5,
          x: 135,
          y: 0
        },
        de_DE: {
          visible: true,
          text: 'Siegesserie',
          style: {
            fontSize: 60,
            dropShadowAngle: 95.3
          },
          x: -105,
          y: 0,
          angle: -3
        },
        es_ES: {
          text: 'Victorias',
          angle: 5,
          style: {
            fontSize: 60,
            dropShadowAngle: 96.3
          },
          x: 150,
          y: 0
        },
        pt_PT: {
          text: 'Vitórias',
          angle: 5,
          x: 170,
          y: 0,
          style: {
            fontSize: 60,
            dropShadowAngle: 96.1
          }
        },
        pl_PL: {
          text: 'Zwycięstw',
          angle: 2,
          style: {
            fontSize: 70,
            dropShadowAngle: 96.1
          },
          x: 110,
          y: 0
        },
        nl_NL: {
          text: 'Winstreek',
          style: {
            fontSize: 75,
            dropShadowAngle: 95.3
          },
          y: -2,
          x: -88,
          angle: -3
        },
        ko_KR: {
          text: '연승의',
          style: {
            fontWeight: 'bolder',
            fontSize: 80,
            dropShadowAngle: 95.5
          },
          y: 0,
          angle: -2,
          x: -50
        },
        jp_JP: {
          text: '連勝の',
          style: {
            fontWeight: 'bolder',
            fontSize: 80,
            dropShadowAngle: 95.3
          },
          y: -5,
          x: -40
        }
      }
    },
    {
      id: '72a61294-173b-4052-87a9-3bb4ef669fab',
      type: 'Text',
      name: '',
      className: '',
      x: -90,
      y: 7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -5,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Streak',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 80,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#fe9c00',
        stroke: '#fff8d9',
        strokeThickness: 10,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 95.8,
        dropShadowBlur: 0,
        dropShadowColor: '#c18d6c',
        dropShadowDistance: 8,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          text: 'delle',
          style: {
            fontSize: 40
          },
          x: -6,
          angle: 0,
          y: -5
        },
        en_US: {
          style: {
            dropShadowAngle: 95.6
          }
        },
        fr_FR: {
          text: 'de',
          style: {
            fontSize: 40
          },
          x: -20,
          y: 0,
          angle: 0
        },
        de_DE: {
          visible: false,
          x: -90,
          y: 0
        },
        es_ES: {
          text: 'de',
          style: {
            fontSize: 50
          },
          angle: 0,
          y: -5,
          x: -10
        },
        pt_PT: {
          text: 'das',
          style: {
            fontSize: 40
          },
          x: 17,
          y: -5,
          angle: 0
        },
        pl_PL: {
          visible: false
        },
        nl_NL: {
          visible: false
        },
        ko_KR: {
          visible: false,
          style: {
            fontSize: 90
          }
        },
        jp_JP: {
          visible: false
        }
      }
    },
    {
      id: '499de731-ab25-4060-a4e1-6270e891a91b',
      type: 'Text',
      name: '',
      className: '',
      x: 135,
      y: 7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 5,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Road',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 80,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#fe9c00',
        stroke: '#fff8d9',
        strokeThickness: 10,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 95.8,
        dropShadowBlur: 0,
        dropShadowColor: '#c18d6c',
        dropShadowDistance: 8,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          text: 'Strada',
          angle: -5,
          x: -162,
          style: {
            fontSize: 65,
            dropShadowAngle: 95.2
          },
          y: 0
        },
        en_US: {
          style: {
            dropShadowAngle: 96.2
          }
        },
        fr_FR: {
          text: 'Route',
          style: {
            fontSize: 70,
            dropShadowAngle: 95.4
          },
          angle: -5,
          x: -150,
          y: 0
        },
        de_DE: {
          text: '-Straße',
          style: {
            fontSize: 60,
            dropShadowAngle: 96.2
          },
          x: 165,
          y: 2,
          angle: 4
        },
        es_ES: {
          text: 'Camino',
          angle: -5,
          x: -153,
          style: {
            fontSize: 60,
            dropShadowAngle: 95.4
          },
          y: 0
        },
        pt_PT: {
          text: 'Caminho',
          angle: -5,
          style: {
            fontSize: 60,
            dropShadowAngle: 95.3
          },
          x: -150,
          y: 0
        },
        pl_PL: {
          text: 'Droga',
          angle: -4,
          style: {
            fontSize: 70,
            dropShadowAngle: 95.5
          },
          x: -175,
          y: 0
        },
        nl_NL: {
          text: '-Weg',
          style: {
            fontSize: 75,
            dropShadowAngle: 96.1
          },
          y: -4,
          x: 180,
          angle: 2
        },
        ko_KR: {
          text: '길',
          style: {
            fontWeight: 'bolder',
            fontSize: 90,
            dropShadowAngle: 96.3
          },
          y: 5,
          angle: 2,
          x: 120
        },
        jp_JP: {
          text: '道',
          style: {
            fontWeight: 'bolder',
            fontSize: 80,
            dropShadowAngle: 96.2
          },
          y: 3,
          x: 125
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'en_US',
    'it_IT',
    'fr_FR',
    'de_DE',
    'es_ES',
    'pt_PT',
    'pl_PL',
    'nl_NL',
    'ko_KR',
    'jp_JP'
  ],
  handleResize: false
} as const;

export class WinStreakLocalizedLogoLayout {
  static raw = raw;
  root!: Container;
  locaSkin_SPL!: (Container)[];
  StateName!: 'en_US' | 'it_IT' | 'fr_FR' | 'de_DE' | 'es_ES' | 'pt_PT' | 'pl_PL' | 'nl_NL' | 'ko_KR' | 'jp_JP';

  constructor() {
    populate(this, raw);
  }
}
